/* PlayShop — Aperçu image au survol (réutilise le pattern de l'admin, en standalone).
   Survol d'un élément [data-ps-card-img] (URL directe) ou [data-ps-card-handle] (lazy /products/{handle}.js)
   → popup flottant suivant le curseur. Idempotent (un seul listener global). */
(function () {
  if (window.__psImgHover) return;
  window.__psImgHover = 1;
  let box = null;
  const ensure = () => {
    if (box) return box;
    box = document.createElement('div');
    box.style.cssText = 'position:fixed;z-index:99999;pointer-events:none;display:none;padding:4px;background:var(--ps-bg-elevated,#15151c);border:1px solid var(--ps-border,#333);border-radius:10px;box-shadow:0 10px 34px rgba(0,0,0,.55);';
    box.innerHTML = '<img alt="" style="display:block;width:230px;height:auto;border-radius:6px;">';
    document.body.appendChild(box);
    return box;
  };
  const place = (e) => {
    if (!box || box.style.display === 'none') return;
    const pad = 16, w = 240;
    let x = e.clientX + pad; if (x + w > window.innerWidth) x = e.clientX - w - pad;
    const h = box.offsetHeight || 330;
    let y = e.clientY + pad; if (y + h > window.innerHeight) y = Math.max(8, window.innerHeight - h - 8);
    box.style.left = x + 'px'; box.style.top = y + 'px';
  };
  const imgCache = new Map();
  async function resolveHandleImg(handle) {
    if (imgCache.has(handle)) return imgCache.get(handle);
    try {
      const r = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
      if (!r.ok) throw 0;
      const p = await r.json();
      let url = p.featured_image || (p.images && p.images[0]) || '';
      if (url) { if (url.startsWith('//')) url = 'https:' + url; url += (url.includes('?') ? '&' : '?') + 'width=420'; }
      imgCache.set(handle, url || ''); return url || '';
    } catch (_) { imgCache.set(handle, ''); return ''; }
  }
  document.addEventListener('mouseover', async (e) => {
    const el = e.target.closest('[data-ps-card-img], [data-ps-card-handle]'); if (!el) return;
    let src = el.getAttribute('data-ps-card-img');
    if (!src) {
      const handle = el.getAttribute('data-ps-card-handle'); if (!handle) return;
      src = await resolveHandleImg(handle);
      if (src) el.setAttribute('data-ps-card-img', src);
      if (!src || !el.matches(':hover')) return;
    }
    const b = ensure(); b.querySelector('img').src = src; b.style.display = 'block'; place(e);
  });
  document.addEventListener('mousemove', (e) => { if (box && box.style.display !== 'none') place(e); });
  document.addEventListener('mouseout', (e) => {
    const el = e.target.closest('[data-ps-card-img], [data-ps-card-handle]'); if (!el) return;
    if (e.relatedTarget && el.contains(e.relatedTarget)) return;
    if (box) box.style.display = 'none';
  });
})();
